import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import elisa from "../../resources/elisa.jpg";
import { WELCOME_CONTENT, SUPPORT_LINKS } from "behaviour-analyzer-shared";
import TopBar from "../../components/layout/topbar";
import Footer from "../../components/layout/footer";

const About = () => {
  const { sections } = WELCOME_CONTENT;
  const { isLoggedIn } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("[About] MONTADO");
    return () => console.log("[About] DESMONTADO");
  }, []);

  const content = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
        backgroundColor: "#f5f5f5",
        color: "#333",
      }}
    >
      {/* Qué es CEAEmociones */}
      <section style={sectionStyle}>
        <h2 style={titleStyle}>{sections.whatIs.title}</h2>
        {sections.whatIs.text.map((paragraph, i) => (
          <p key={i} style={paragraphStyle}>{paragraph}</p>
        ))}
      </section>

      {/* Por qué nace este proyecto */}
      <section style={sectionStyle}>
        <h2 style={titleStyle}>{sections.whyProject.title}</h2>
        <p style={paragraphStyle}>{sections.whyProject.intro}</p>
        <ol style={{ textAlign: "left", display: "inline-block", fontSize: "clamp(0.9rem, 2.5vw, 1rem)", lineHeight: "1.8" }}>
          {sections.whyProject.reasons.map((reason, i) => (
            <li key={i}>
              <strong>{reason.label}</strong> {reason.text}
            </li>
          ))}
        </ol>
      </section>

      {/* Detrás del proyecto */}
      <section style={sectionStyle}>
        <h2 style={titleStyle}>{sections.behindProject.title}</h2>
        <img
          src={elisa}
          alt="Elisa Toledo Arrom"
          style={{
            width: "min(300px, 70vw)",
            height: "min(300px, 70vw)",
            borderRadius: "50%",
            objectFit: "cover",
            marginBottom: "20px",
          }}
        />
        {sections.behindProject.text.map((paragraph, i) => {
          // Aplicar negrita a los nombres
          let content = paragraph;
          const boldNames = sections.behindProject.boldNames || [];
          const parts = [];
          let remaining = content;

          if (boldNames.length > 0) {
            // Dividir el texto por los nombres en negrita
            const regex = new RegExp(`(${boldNames.join("|")})`, "g");
            const splitParts = remaining.split(regex);
            splitParts.forEach((part, j) => {
              if (boldNames.includes(part)) {
                parts.push(<strong key={j}>{part}</strong>);
              } else {
                parts.push(part);
              }
            });
          } else {
            parts.push(content);
          }

          return <p key={i} style={paragraphStyle}>{parts}</p>;
        })}
      </section>

      {/* Apóyanos */}
      <section style={sectionStyle}>
        <h2 style={titleStyle}>{sections.support.title}</h2>
        {sections.support.text.map((paragraph, i) => (
          <p key={i} style={paragraphStyle}>{paragraph}</p>
        ))}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            flexWrap: "wrap",
            marginTop: "20px",
          }}
        >
          <a
            href={SUPPORT_LINKS.buyMeACoffee}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button
              type="button"
              style={{
                padding: "12px 24px",
                backgroundColor: "#FF813F",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                fontSize: "clamp(0.9rem, 2.5vw, 1rem)",
                cursor: "pointer",
              }}
            >
              Buy Me a Coffee
            </button>
          </a>
          <a
            href={SUPPORT_LINKS.paypal}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button
              type="button"
              style={{
                padding: "12px 24px",
                backgroundColor: "#003087",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                fontSize: "clamp(0.9rem, 2.5vw, 1rem)",
                cursor: "pointer",
              }}
            >
              PayPal
            </button>
          </a>
        </div>
      </section>

      {/* Botón Empezar */}
      <div style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "20px",
        marginBottom: "40px",
      }}>
        <button
          type="button"
          onClick={() => navigate(isLoggedIn ? "/modo" : "/login")}
          style={{
            padding: "15px 30px",
            backgroundColor: "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            fontSize: "clamp(1rem, 3vw, 1.2rem)",
            cursor: "pointer",
          }}
        >
          {WELCOME_CONTENT.startButton}
        </button>
      </div>
    </div>
  );

  if (isLoggedIn) {
    return (
      <div className="d-flex flex-column min-vh-100">
        <TopBar />
        <div className="flex-grow-1 d-flex flex-column">
          {content}
        </div>
        <Footer />
      </div>
    );
  }

  return content;
};

const sectionStyle = {
  maxWidth: "800px",
  width: "100%",
  textAlign: "center",
  marginBottom: "40px",
  padding: "0 15px",
};

const titleStyle = {
  fontSize: "clamp(1.3rem, 4vw, 1.8rem)",
};

const paragraphStyle = {
  fontSize: "clamp(0.9rem, 2.5vw, 1rem)",
  lineHeight: "1.6",
};

export default About;
